import { QueryReturnValue } from '@reduxjs/toolkit/query'
import { AxiosError } from 'axios'

interface PromiseLike<T> {
  /**
   * Attaches callbacks for the resolution and/or rejection of the Promise.
   * @param onfulfilled The callback to execute when the Promise is resolved.
   * @param onrejected The callback to execute when the Promise is rejected.
   * @returns A Promise for the completion of which ever callback is executed.
   */
  then<TResult1 = T, TResult2 = never>(
    onfulfilled?:
      | ((value: T) => TResult1 | PromiseLike<TResult1>)
      | undefined
      | null,
    onrejected?:
      | ((reason: any) => TResult2 | PromiseLike<TResult2>)
      | undefined
      | null
  ): PromiseLike<TResult1 | TResult2>
}

type MaybePromise<T> = T | PromiseLike<T> //TODO: NEEDS TESTING, no longer imported from toolkit. use any?

const settleAllQueries = async (
  promises: MaybePromise<QueryReturnValue<unknown, unknown, {}>>[]
) => {
  const results = await Promise.allSettled(promises)
  const resolved: QueryReturnValue<unknown, unknown, {}>[] = []
  const rejected: QueryReturnValue<unknown, AxiosError, {}>[] = []

  for (const result of results) {
    if (result.status === 'fulfilled') {
      resolved.push(result.value)
    } else {
      rejected.push(result.reason)
    }
  }

  const resolvedAsData = resolved.map((r) => r.data)
  const rejectedAsError = rejected.map((r) => r.error)

  return { resolved: resolvedAsData, rejected: rejectedAsError }
}

export default settleAllQueries
